import { render, staticRenderFns } from "./BeforeOtsComponent.vue?vue&type=template&id=2fea8a34&"
import script from "./BeforeOtsComponent.vue?vue&type=script&lang=ts&"
export * from "./BeforeOtsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fea8a34')) {
      api.createRecord('2fea8a34', component.options)
    } else {
      api.reload('2fea8a34', component.options)
    }
    module.hot.accept("./BeforeOtsComponent.vue?vue&type=template&id=2fea8a34&", function () {
      api.rerender('2fea8a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/OfficerTrainingSchoolFlyout/BeforeOtsComponent.vue"
export default component.exports